export const LoginView = () => import('./LoginView.vue')
export const ProjectsView = () => import('./ProjectsView.vue')
export const EditorView = () => import('./EditorView.vue')
export const AssetsView = () => import('./AssetsView.vue')
export const VersionsView = () => import('./VersionsView.vue')
export const TurnVideosView = () => import('./TurnVideosView.vue')
export const RunListView = () => import('./RunListView.vue')
export const RunChainView = () => import('./RunChainView.vue')
export const LocalizationView = () => import('./LocalizationView.vue')
export const NovelProjectsView = () => import('./novel/NovelProjectsView.vue')
export const NovelEditorView = () => import('./novel/NovelEditorView.vue')
